import classNames from 'classnames/bind';
import AdditionalServices from 'common/priceTransparency/AdditionalServices';
import Baggage from 'common/priceTransparency/Baggage';
import CancelChange from 'common/priceTransparency/CancelChange';
import { IKeyAnyValue } from 'common/types';
import {
  IModalComponent,
  Modal,
  ModalFuncContext,
  ModalPosition,
} from 'contexts/modalFunc';
import { usePriceTransparency } from 'contexts/priceTransparency';
import { useContext, useState } from 'react';
import styles from './index.module.scss';

const cx = classNames.bind(styles);
const menuList = [
  { name: '환불/취소', clickCode: 'refund' },
  { name: '일정 변경', clickCode: 'change' },
  { name: '수하물', clickCode: 'baggage' },
  { name: '마일리지 등', clickCode: 'mileage' },
];

const Modals: IKeyAnyValue = {
  [Modal.POLICY]: () => {
    const setModal = useContext(ModalFuncContext);
    const { priceTransparency } = usePriceTransparency();
    const [currentMenuIndex, setCurrentMenuIndex] = useState(0);
    const changeMenu = (index: number) => setCurrentMenuIndex(index);
    const closeModal = () =>
      setModal({ type: Modal.NULL, position: ModalPosition.MAIN });

    if (!priceTransparency) {
      return null;
    }

    return (
      <div className={cx('PolicyModalContainer_Policy')}>
        <div className={cx('top')}>
          <div className={cx('header')}>
            <b className={cx('title')}>항공권 규정</b>
            <button
              className={cx('close')}
              type="button"
              aria-label="닫기"
              data-event-nlog="click"
              data-event-area-code="idt.ptclose"
              onClick={closeModal}
            />
          </div>
          <div className={cx('tabs', 'policy')}>
            {menuList.map(({ name, clickCode }, index) => (
              <button
                key={index}
                className={cx('tab')}
                type="button"
                aria-selected={index === currentMenuIndex}
                data-event-nlog="click"
                data-event-area-code={`idt.pt${clickCode}`}
                onClick={() => changeMenu(index)}
              >
                <span className={cx('name')}>{name}</span>
              </button>
            ))}
          </div>
        </div>
        {currentMenuIndex === 0 && (
          <CancelChange
            policyList={priceTransparency.map(({ policy }) => policy?.cancel)}
            type="cancel"
          />
        )}
        {currentMenuIndex === 1 && (
          <CancelChange
            policyList={priceTransparency.map(({ policy }) => policy?.change)}
            type="change"
          />
        )}
        {currentMenuIndex === 2 && (
          <Baggage
            baggagePolicy={priceTransparency.map(
              ({ policy }) => policy?.baggage,
            )}
          />
        )}
        {currentMenuIndex === 3 && (
          <AdditionalServices priceTransparency={priceTransparency} />
        )}
      </div>
    );
  },
};

const PolicyModalContainer = ({
  modalInfo: { type, payload },
}: IModalComponent) => {
  const ModalComponent = Modals[type];
  if (!ModalComponent) return null;

  return (
    <div className={cx('PolicyModalContainer')} aria-modal="true">
      <div className={cx('content')}>
        <ModalComponent payload={payload} />
      </div>
    </div>
  );
};

export default PolicyModalContainer;
